/**
 * Resizable Image extension for TipTap.
 * Extends the default Image extension with a `width` attribute
 * and a React NodeView that provides drag-to-resize handles.
 */

import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ResizableImageView } from '../components/content/rich-text/ResizableImageView';
import { mediaLayoutAttributes } from './tiptap-media-layout';

export const ResizableImage = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            // EAA-1736: inline / block / wrap / behind / front placement.
            ...mediaLayoutAttributes(),
            width: {
                default: null,
                parseHTML: (element) => {
                    const w =
                        element.getAttribute('width') ||
                        element.style.width;
                    if (!w) return null;
                    const num = parseInt(String(w), 10);
                    return isNaN(num) ? null : num;
                },
                renderHTML: (attributes) => {
                    if (!attributes.width) return {};
                    return { width: attributes.width };
                },
            },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(ResizableImageView);
    },
});

export default ResizableImage;
